import { createContext, useContext } from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'
import { TFieldValues } from 'pages/configuration/LmsProfiles/common/types'
import { profileFormValidations } from 'pages/configuration/LmsProfiles/common/validations'
import { LmsProfileTypes } from 'enum/lms-profile-types.enum'

type CreateProfileValues = TFieldValues & {
  users: {
    userId: number
  }[]
  segments: {
    segmentId: number
  }[]
}

type CreateProfileContextValues = Pick<
  UseFormReturn<CreateProfileValues, any>,
  'control' | 'getValues' | 'setValue' | 'formState' | 'watch'
>

export const CreateProfileContext = createContext<CreateProfileContextValues>(
  Object.create(null)
)

export const CreateProfileProvider: React.FC = ({ children }) => {
  const { control, getValues, formState, setValue, watch } =
    useForm<CreateProfileValues>({
      defaultValues: {
        name: '',
        color: '#000000',
        profileType: LmsProfileTypes.allUsers,
        users: [],
        segments: [],
      },
      resolver: (data) => {
        const errors = profileFormValidations(data)

        const profileType = data.profileType
        if (profileType === LmsProfileTypes.participants)
          if (!data.users.length) errors.users = true

        if (profileType === LmsProfileTypes.segments)
          if (!data.segments.length) errors.segments = true

        return {
          errors,
          values: data,
        }
      },
      reValidateMode: 'onChange',
      mode: 'all',
    })

  return (
    <CreateProfileContext.Provider
      value={{
        control,
        getValues,
        setValue,
        formState,
        watch,
      }}
    >
      {children}
    </CreateProfileContext.Provider>
  )
}

export const useCreateProfile = () => useContext(CreateProfileContext)
